var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "payment-plan-page",
      attrs: { "aria-label": _vm.$t("payment-plans.heading") }
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "plan-state", attrs: { role: "status" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary", size: "34" }
              }),
              _c("span", [_vm._v(_vm._s(_vm.$t("payment-plans.loading")))])
            ],
            1
          )
        : _vm.loadError
        ? _c(
            "div",
            { staticClass: "plan-state", attrs: { role: "alert" } },
            [
              _c("portal-icon", { attrs: { name: "alert-circle", size: 28 } }),
              _c("span", [_vm._v(_vm._s(_vm.$t("payment-plans.load-error")))]),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("refresh")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("payment-plans.try-again")))]
              )
            ],
            1
          )
        : !_vm.plans.length
        ? _c(
            "div",
            { staticClass: "plan-state" },
            [
              _c("portal-icon", {
                attrs: { name: "calendar-check", size: 30 }
              }),
              _c("strong", [_vm._v(_vm._s(_vm.$t("payment-plans.no-active")))]),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("payment-plans.no-active-detail")))
              ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "plan-list" },
            _vm._l(_vm.plans, function(plan) {
              return _c(
                "details",
                {
                  key: plan.id,
                  staticClass: "plan-card",
                  attrs: { open: plan.id === _vm.highlightedPlanId }
                },
                [
                  _c(
                    "summary",
                    [
                      _c("div", { staticClass: "plan-heading" }, [
                        _c(
                          "div",
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  plan.name || _vm.$t("payment-plans.untitled")
                                )
                              )
                            ]),
                            _c(
                              "portal-status-pill",
                              {
                                attrs: {
                                  color:
                                    plan.state === "REVIEWING"
                                      ? "var(--v-warning-base)"
                                      : "var(--v-success-base)",
                                  background:
                                    plan.state === "REVIEWING"
                                      ? "var(--v-warning_10-base)"
                                      : "var(--v-success_10-base)"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "payment-plans.states." +
                                          plan.state.toLowerCase()
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm.next(plan)
                          ? _c("span", { staticClass: "plan-next" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("payment-plans.next")) +
                                  ": " +
                                  _vm._s(_vm.next(plan).label) +
                                  " · " +
                                  _vm._s(_vm.trigger(plan, _vm.next(plan))) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _c("div", { staticClass: "plan-balance" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.money(plan.remaining, plan.currency))
                          )
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("payment-plans.remaining")))
                        ])
                      ]),
                      _c("portal-icon", {
                        attrs: { name: "chevron-down", size: 20 }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "plan-content" }, [
                    _c("div", { staticClass: "plan-metrics" }, [
                      _c("div", [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("payment-plans.plan-total")))
                        ]),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.money(plan.planTotal, plan.currency))
                          )
                        ])
                      ]),
                      _c("div", [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("payment-plans.open-invoices")))
                        ]),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.money(plan.openInvoiceBalance, plan.currency)
                            )
                          )
                        ])
                      ]),
                      _c("div", [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("payment-plans.scheduled-later"))
                          )
                        ]),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.money(plan.scheduledLater, plan.currency)
                            )
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "p",
                      { staticClass: "collection-note" },
                      [
                        _c("portal-icon", {
                          attrs: {
                            name: plan.autoCharge ? "credit-card" : "send",
                            size: 17
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.collectionLabel(plan)) +
                              " " +
                              _vm._s(_vm.terms(plan))
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "ol",
                      { staticClass: "plan-timeline" },
                      _vm._l(plan.steps, function(step) {
                        return _c(
                          "li",
                          { key: step.id, class: step.state.toLowerCase() },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "step-mark",
                                attrs: { "aria-hidden": "true" }
                              },
                              [
                                _c("portal-icon", {
                                  attrs: { name: _vm.stepIcon(step), size: 15 }
                                })
                              ],
                              1
                            ),
                            _c("div", { staticClass: "step-copy" }, [
                              _c("div", { staticClass: "step-title" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      step.label ||
                                        _vm.$t("payment-plans.payment")
                                    )
                                  )
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.money(step.amount, plan.currency)
                                    )
                                  )
                                ])
                              ]),
                              _c("small", [
                                _vm._v(_vm._s(_vm.trigger(plan, step)))
                              ]),
                              step.invoiceId
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "invoice-link",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openInvoice(step.invoiceId)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "payment-plans.view-invoice",
                                              {
                                                number:
                                                  step.invoiceNumberFormatted
                                              }
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _c("span", { staticClass: "step-state" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "payment-plans.step-states." +
                                      step.state.toLowerCase()
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]
              )
            }),
            0
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }